import { render, staticRenderFns } from "./scqycxqkb.vue?vue&type=template&id=299838f0&scoped=true&"
import script from "./scqycxqkb.vue?vue&type=script&lang=js&"
export * from "./scqycxqkb.vue?vue&type=script&lang=js&"
import style0 from "./scqycxqkb.vue?vue&type=style&index=0&id=299838f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299838f0",
  null
  
)

export default component.exports